import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-iframe-validation-success',
  templateUrl: './iframe-validation-success.component.html',
  styleUrls: ['./iframe-validation-success.component.scss'],
})
export class IframeValidationSuccessComponent implements OnInit, OnDestroy {
  // Contador regressivo em segundos
  remainingSeconds: number = 3;
  private countdownInterval: any;
  private status: string;

  constructor(private route: ActivatedRoute) {
    // Status pode vir como parâmetro da URL (success ou error)
    this.status = this.route.snapshot.queryParams['status'] || 'success';
  }

  ngOnInit(): void {
    // Inicia a contagem regressiva
    this.startCountdown();
  }

  ngOnDestroy(): void {
    // Limpa o intervalo quando o componente é destruído
    this.clearCountdown();
  }

  /**
   * Inicia a contagem regressiva e agenda o envio da mensagem
   */
  private startCountdown(): void {
    // Atualiza o contador a cada segundo
    this.countdownInterval = setInterval(() => {
      this.remainingSeconds--;

      if (this.remainingSeconds <= 0) {
        // Quando chegar a zero, envia a mensagem e limpa o contador
        this.clearCountdown();
        this.sendMessageToParent();
      }
    }, 1000);
  }

  /**
   * Limpa o intervalo da contagem regressiva
   */
  private clearCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  /**
   * Envia mensagem para o componente pai (VeriffKycProviderComponent)
   * que está exibindo esta página em um iframe
   */
  private sendMessageToParent(): void {
    // Verifica se estamos em um iframe
    if (window.top !== window.self) {
      try {
        // Envia mensagem para o componente pai
        // TODO: Melhorar a segurança da mensagem, restringindo a origem e mandando algo do cliente que abriu o iframe
        window.parent.postMessage(
          { type: this.status === 'error' ? 'veriff-error' : 'veriff-success' },
          '*' // Permite que qualquer origem receba a mensagem
        );

        console.log(`Mensagem enviada para o componente pai: ${this.status}`);
      } catch (error) {
        console.error('Erro ao enviar mensagem para o componente pai:', error);
      }
    } else {
      console.log('Esta página não está em um iframe');
    }
  }
}
